import { render, staticRenderFns } from "./QuestionHistoryList.vue?vue&type=template&id=735ba34c&scoped=true&"
import script from "./QuestionHistoryList.vue?vue&type=script&lang=js&"
export * from "./QuestionHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionHistoryList.vue?vue&type=style&index=0&id=735ba34c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ba34c",
  null
  
)

export default component.exports